import EditCreditCardForm from "legacy/credit-cards/EditCreditCardForm"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class EditCreditCardModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      saving: false,
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.saving = this.saving.bind(this)
    this.editCreditCardForm = null
    this.setEditCreditCardFormRef = (element) => {
      this.editCreditCardForm = element
    }
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  save() {
    this.editCreditCardForm.save()
  }

  saving(boolean) {
    this.setState({
      saving: boolean,
    })
  }

  renderModal() {
    const {
      card: {
        exp_year: expYear,
        exp_month: expMonth,
        external_id: cardId,
        zip,
      },
      endpoint,
      successCallback,
      title = "Edit Card Details",
    } = this.props

    return (
      <Modal
        isOpen={this.state.showModal}
        onClose={this.closeModal}
        size="mediumFixed"
      >
        <Modal.Header title={title} />
        <Modal.Body>
          <EditCreditCardForm
            ref={this.setEditCreditCardFormRef}
            cardId={cardId}
            expirationMonth={expMonth}
            expirationYear={expYear}
            zip={zip}
            endpoint={endpoint}
            saving={this.saving}
            successCallback={successCallback}
          />
        </Modal.Body>
        <Modal.Footer
          cancelBtnText="Cancel"
          confirmBtnText="Save"
          onClose={this.closeModal}
          onSubmit={this.save}
          confirmBtnLoading={this.state.saving}
        />
      </Modal>
    )
  }

  buttonText() {
    return this.props.buttonText || "Edit Card"
  }

  render() {
    if (this.props.customElementTrigger) {
      return (
        <span onClick={this.openModal} className="cursor-pointer">
          {this.props.customElementTrigger}
          {this.renderModal()}
        </span>
      )
    }
    return (
      <div>
        <button
          type="button"
          className={this.props.buttonClass || "btn btn-link"}
          onClick={this.openModal}
        >
          {this.buttonText()}
        </button>
        {this.renderModal()}
      </div>
    )
  }
}

EditCreditCardModal.propTypes = {
  title: PropTypes.string,
  buttonText: PropTypes.string,
  buttonClass: PropTypes.string,
  endpoint: PropTypes.string.isRequired,
  successCallback: PropTypes.func,
  customElementTrigger: PropTypes.node,
  card: PropTypes.shape({
    exp_year: PropTypes.number.isRequired,
    exp_month: PropTypes.number.isRequired,
    external_id: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired,
  }).isRequired,
}

export default EditCreditCardModal
